import { BrazilDate } from "../../../../utils/BrazilDate";

export const WEBHOOK_EVENTO_RESUMO_MAX = 60;

export const formatWebhookEventoDate = (dateStr: string) =>
  BrazilDate.formatBR(new Date(dateStr), true);

export const resumoWebhookPayload = (payload: Record<string, unknown>) => {
  const s = JSON.stringify(payload);
  return s.length <= WEBHOOK_EVENTO_RESUMO_MAX
    ? s
    : `${s.slice(0, WEBHOOK_EVENTO_RESUMO_MAX)}…`;
};
